import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/client-provider/auth.service';
import { LoginModel } from 'src/app/client-provider/client';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginModel: LoginModel = new LoginModel();
  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
  }

  login(){
    if(this.loginModel !== undefined)
      this.authService.loginIn(this.loginModel).subscribe(data => {
        this.authService.setToken(data);
        this.router.navigateByUrl('panel');
      });
  }
}
